import type { FaireProductEntity } from "../../entity_types/product";

export const p_9cmucmvhsr: FaireProductEntity = {
  token: "p_9cmucmvhsr",
  type: "product",
  name: "Grateful Dead Retro Drinking Glass Set - Terrapin, Stealie,",
  brandToken: "b_a4f92b9b",
  brandName: "AQUARIUS, GAMAGO, ICUP, & ROCK SAWS by NMR Brands",
  imageUrl:
    "https://cdn.faire.com/fastly/f16eead61070ed07115c3a822a4a7e3d3d720a97348d994cb98a4d832eb167da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da636ff392aa255182b5fd706e7c8fc4c875f9981b5f44ecabe609c397760a02.jpeg",
    "https://cdn.faire.com/fastly/323a6629dd7f7374814e7941549438cf0c35f23970b7a618a3c07adc807c15fc.jpeg",
    "https://cdn.faire.com/fastly/56b8062175163942d6adece8bb661d2c840024fde1674f33a615d673584e601d.jpeg",
  ],
  priceDollars: 24.11,
  description:
    "Grateful Dead Retro Drinking Glass Set - Terrapin, Stealie, Bear, Skeleton (4-Pack / 16oz / Packaged)\n\nDRINKWARE DESIGNED FOR FUN & FUNCTIONALITY: This 4 piece set of Grateful Dead 16 oz pint glasses is the ultimate item or gift for Grateful Dead fans of all ages. Each glass holds 16 ozs and features its own album image from the bands most popular releases. It's a perfect way to start your day, end your day or for that matter, just enjoy your day or night! Great for yourself or as white elephant and Holidays gifts. Adults and kids will absolutely and proudly show their love with these Grateful Dead 16 oz Pint Glasss. \n\nLOOKING FOR GRATEFUL DEAD GIFTS? This Grateful Dead Retro Pint Glass Set 4 Pack is the ultimate gift for fans of all ages. it's perfect for gatherings, birthdays, holidays, kids and adults will absolutely love receiving it as a gift.\n\nPREMIUM QUALITY YOU CAN TRUST: Our drinkware combines quality craftsmanship with a high dose of fun!\n\n100% OFFICIALLY LICENSED GRATEFUL DE",
  tags: [],
  msrpDollars: 48.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:11.836Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
